module.exports = __webpack_public_path__ + "static/img/27.d955c01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/digitalize/27.png
// module id = g6aa
// module chunks = 2